/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Celerity.API | v1
 * OpenAPI spec version: 1.0.0
 */

/**
 * Types of an Organization.
 */
export type OrganizationTypes = typeof OrganizationTypes[keyof typeof OrganizationTypes];


export const OrganizationTypes = {
  Administrator: 'Administrator',
  Manufacturer: 'Manufacturer',
  Distributor: 'Distributor',
} as const;
